module.exports = __webpack_public_path__ + "img/huntica.8920199e.svg";